(function () {
  'use strict'
  const container = document.querySelector('[data-lo-search]')
  if (!container) return
  const input = container.querySelector('[data-lo-search-input]')
  const suggest = container.querySelector('[data-lo-suggest]')
  const form = container.querySelector('form')
  if (!input || !suggest || !form) return

  let debounceTimer = null
  let lastQuery = ''
  let currentFocus = -1
  const btn = container.querySelector('[data-lo-search-btn]')

  const frame = document.getElementById('lo-header')
  if (frame && suggest.parentElement !== frame) {
    frame.appendChild(suggest)
    suggest.classList.add('is-detached')
  }

  function placeSuggest () {
    if (!frame || !suggest.classList.contains('is-detached')) return
    const box = form.getBoundingClientRect()
    const base = frame.getBoundingClientRect()
    suggest.style.left = box.left - base.left + 'px'
    suggest.style.top = box.bottom - base.top + 6 + 'px'
    suggest.style.width = box.width + 'px'
  }

  function syncButtonState () {
    if (!btn) return
    const hasValue = input.value.length > 0
    if (hasValue) {
      btn.classList.add('is-clear')
      btn.setAttribute('aria-label', 'Clear search')
      btn.setAttribute('type', 'button')
    } else {
      btn.classList.remove('is-clear')
      btn.setAttribute('aria-label', 'Search')
      btn.setAttribute('type', 'submit')
    }
  }

  if (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.classList.contains('is-clear')) {
        e.preventDefault()
        input.value = ''
        lastQuery = ''
        hideSuggest()
        syncButtonState()
        input.focus()
      }
    })
  }

  function moneyFormat (amount) {
    const parsed = parseFloat(amount)
    if (isNaN(parsed)) return amount
    return '$' + parsed.toFixed(2)
  }

  // The suggestions API returns prices as a string in units ("149.99") and sometimes
  // as a number in cents. They are normalised to a number in units, or NaN when there
  // is no price, so both cases can be compared and formatted the same way.
  function toPrice (value) {
    if (value === null || value === undefined || value === '') return NaN
    if (typeof value === 'number') return value / 100
    const parsed = parseFloat(String(value).replace(/[^0-9.\-]/g, ''))
    return isNaN(parsed) ? NaN : parsed
  }

  function renderResults (data, query) {
    const products =
      (data.resources && data.resources.results && data.resources.results.products) || []
    const collections =
      (data.resources && data.resources.results && data.resources.results.collections) || []
    const queries =
      (data.resources && data.resources.results && data.resources.results.queries) || []

    if (products.length === 0 && collections.length === 0 && queries.length === 0) {
      suggest.innerHTML =
        '<div class="lo-hdr-suggest-empty">No matches for "<strong>' +
        escapeHtml(query) +
        '</strong>".</div>'
      return
    }

    let html = ''

    if (queries.length > 0) {
      html += '<div class="lo-hdr-suggest-section">Suggestions</div>'
      queries.slice(0, 4).forEach(function (suggestion) {
        html +=
          '<a class="lo-hdr-suggest-collection" href="' +
          form.action +
          '?q=' +
          encodeURIComponent(suggestion.text) +
          '" data-lo-suggest-item role="option">' +
          '<svg class="lo-hdr-suggest-collection-icon" viewBox="0 0 20 20" fill="none">' +
          '<path d="M17 17l-3.5-3.5M15 9A6 6 0 1 1 3 9a6 6 0 0 1 12 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>' +
          '<span class="lo-hdr-suggest-title">' +
          (suggestion.styled_text || escapeHtml(suggestion.text)) +
          '</span>' +
          '</a>'
      })
    }

    if (collections.length > 0) {
      if (html) html += '<div class="lo-hdr-suggest-divider"></div>'
      html += '<div class="lo-hdr-suggest-section">Collections</div>'
      collections.slice(0, 3).forEach(function (collection) {
        html +=
          '<a class="lo-hdr-suggest-collection" href="' +
          collection.url +
          '" data-lo-suggest-item role="option">' +
          '<svg class="lo-hdr-suggest-collection-icon" viewBox="0 0 20 20" fill="none">' +
          '<rect x="3" y="3" width="14" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>' +
          '<path d="M3 8h14M8 3v14" stroke="currentColor" stroke-width="1.5"/>' +
          '</svg>' +
          '<span class="lo-hdr-suggest-title">' +
          escapeHtml(collection.title) +
          '</span>' +
          '</a>'
      })
    }

    if (products.length > 0) {
      if (html) html += '<div class="lo-hdr-suggest-divider"></div>'
      html += '<div class="lo-hdr-suggest-section">Products</div>'
      products.slice(0, 5).forEach(function (product) {
        const img =
          product.featured_image && product.featured_image.url
            ? product.featured_image.url
            : product.image || suggest.dataset.placeholder || ''
        // "0.00" is a string, and every non-empty string is truthy: that is why
        // the previous price was struck through at zero, as if the product had
        // been free. It is compared as a number now and only shown when it
        // really is higher than the current one.
        const price = toPrice(product.price)
        const compare = toPrice(
          product.compare_at_price_min !== undefined
            ? product.compare_at_price_min
            : product.compare_at_price
        )
        html +=
          '<a class="lo-hdr-suggest-item" href="' +
          product.url +
          '" data-lo-suggest-item role="option">' +
          '<div class="lo-hdr-suggest-img">' +
          (img ? '<img src="' + img + '" alt=""/>' : '') +
          '</div>' +
          '<div class="lo-hdr-suggest-text">' +
          '<p class="lo-hdr-suggest-title">' +
          escapeHtml(product.title) +
          '</p>' +
          (product.vendor
            ? '<p class="lo-hdr-suggest-meta">' + escapeHtml(product.vendor) + '</p>'
            : '') +
          '</div>' +
          (isFinite(price)
            ? '<span class="lo-hdr-suggest-price">' + moneyFormat(price) + '</span>'
            : '') +
          (isFinite(compare) && compare > price
            ? '<span class="lo-hdr-suggest-price-was">' + moneyFormat(compare) + '</span>'
            : '') +
          '</a>'
      })
    }

    html +=
      '<div class="lo-hdr-suggest-footer"><a href="' +
      form.action +
      '?q=' +
      encodeURIComponent(query) +
      '" data-lo-suggest-item role="option">See all results for "' +
      escapeHtml(query) +
      '"</a></div>'
    suggest.innerHTML = html
  }

  function escapeHtml (str) {
    if (str == null) return ''
    return String(str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]
    })
  }

  function showSuggest () {
    placeSuggest()
    suggest.classList.add('is-open')
    input.setAttribute('aria-expanded', 'true')
  }
  function hideSuggest () {
    suggest.classList.remove('is-open')
    input.setAttribute('aria-expanded', 'false')
    currentFocus = -1
    input.removeAttribute('aria-activedescendant')
  }

  function fetchSuggestions (query) {
    suggest.innerHTML = '<div class="lo-hdr-suggest-loading">Searching…</div>'
    showSuggest()
    const url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=hide'
    fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : { resources: { results: {} } }
      })
      .then(function (data) {
        if (input.value.trim() !== query) return // stale response
        renderResults(data, query)
        showSuggest()
      })
      .catch(function () {
        suggest.innerHTML = '<div class="lo-hdr-suggest-empty">Couldn\'t load suggestions.</div>'
      })
  }

  input.addEventListener('input', function () {
    syncButtonState()
    const query = input.value.trim()
    clearTimeout(debounceTimer)
    if (query.length < 2) {
      hideSuggest()
      lastQuery = ''
      return
    }
    debounceTimer = setTimeout(function () {
      if (query === lastQuery) return
      lastQuery = query
      fetchSuggestions(query)
    }, 180)
  })

  syncButtonState()

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && suggest.innerHTML) showSuggest()
  })

  window.addEventListener(
    'resize',
    function () {
      if (suggest.classList.contains('is-open')) placeSuggest()
    },
    { passive: true }
  )

  document.addEventListener('click', function (e) {
    if (!container.contains(e.target) && !suggest.contains(e.target)) hideSuggest()
  })

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideSuggest()
  })

  input.addEventListener('keydown', function (e) {
    const items = suggest.querySelectorAll('[data-lo-suggest-item]')
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      currentFocus = Math.min(currentFocus + 1, items.length - 1)
      updateFocus(items)
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      currentFocus = Math.max(currentFocus - 1, -1)
      updateFocus(items)
    } else if (e.key === 'Enter') {
      if (currentFocus >= 0 && items[currentFocus]) {
        e.preventDefault()
        items[currentFocus].click()
      }
    }
  })
  function updateFocus (items) {
    items.forEach(function (item, i) {
      if (!item.id) item.id = 'lo-sug-op-' + i
      const isCurrent = i === currentFocus
      item.classList.toggle('is-focused', isCurrent)
      item.setAttribute('aria-selected', isCurrent ? 'true' : 'false')
      if (isCurrent) item.scrollIntoView({ block: 'nearest' })
    })
    if (currentFocus >= 0 && items[currentFocus]) {
      input.setAttribute('aria-activedescendant', items[currentFocus].id)
    } else {
      input.removeAttribute('aria-activedescendant')
    }
  }
})();
(function () {
  const items = Array.prototype.slice
    .call(document.querySelectorAll('.lo-nav-item'))
    .filter(function (item) {
      return item.querySelector('.lo-mega')
    })
  if (!items.length) return
  let timer
  function closeAll (except) {
    items.forEach(function (item) {
      if (item !== except) item.classList.remove('is-open')
    })
  }
  items.forEach(function (item) {
    function open () {
      clearTimeout(timer)
      closeAll(item)
      item.classList.add('is-open')
    }
    item.addEventListener('mouseenter', open)
    item.addEventListener('mouseleave', function () {
      clearTimeout(timer)
      timer = setTimeout(function () {
        item.classList.remove('is-open')
      }, 180)
    })
    item.addEventListener('focusin', open)
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) item.classList.remove('is-open')
    })
  })
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null)
  })

  // The team columns scroll horizontally and a mouse wheel only turns vertically:
  // without this there would be no way to reach Ohio State with a mouse.
  document.querySelectorAll('.lo-mega-cols').forEach(function (list) {
    list.addEventListener(
      'wheel',
      function (e) {
        if (e.deltaY === 0 || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return
        if (list.scrollWidth <= list.clientWidth) return
        const before = list.scrollLeft
        list.scrollLeft = before + e.deltaY
        if (list.scrollLeft !== before) e.preventDefault()
      },
      { passive: false }
    )
  })
})()
